import { createSlice } from '@reduxjs/toolkit'
import { applicationAccessPermAdd } from './application-oper.actions'

export interface ApplicationAccessState {
  status: {
    [key: string]: 'idle' | 'loading' | 'loaded' | 'failed'
  }
  error: string | null
}

const initialState = {
  status: {},
  error: null,
}

export const ApplicationAccessSlice = createSlice({
  name: 'ApplicationAccess',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(applicationAccessPermAdd.pending, (state, action) => {
      state.status[action.meta.arg.instanceName] = 'loading'
    })
    builder.addCase(applicationAccessPermAdd.fulfilled, (state, action) => {
      state.status[action.meta.arg.instanceName] = 'loaded'
    })
    builder.addCase(applicationAccessPermAdd.rejected, (state, action) => {
      state.status[action.meta.arg.instanceName] = 'failed'
    })
  },
})

export const applicationAccessReducer = ApplicationAccessSlice.reducer
